/* ============
 * Global formatters
 * ============
 *
 * Former global Vue filters (`Vue.filter`), removed in Vue 3. They are exposed
 * as global properties `$capitalize`, `$round`, `$formatNumber` and `$tel`
 * so templates can call them like any other method. The `$` prefix keeps them
 * from clashing with component-local methods of the same name.
 */
import numeral from 'numeral';
import 'numeral/locales/fr';
import tel from './tel';

numeral.locale('fr');

export function capitalize(text) {
  return text.charAt(0)
    .toUpperCase() + text.substr(1);
}

export function round(value, decimals) {
  const safeValue = value || 0;
  const safeDecimals = decimals || 0;

  return Math.round(safeValue * (10 ** safeDecimals)) / (10 ** safeDecimals);
}

export function formatNumber(value) {
  return numeral(parseFloat(value))
    .format('0[.]00');
}

export { tel };

export default {
  install(app) {
    Object.assign(app.config.globalProperties, {
      $capitalize: capitalize,
      $round: round,
      $formatNumber: formatNumber,
      $tel: tel,
    });
  },
};
